import { render, staticRenderFns } from "./HeaderCenter.vue?vue&type=template&id=7480e7a0&scoped=true"
import script from "./HeaderCenter.vue?vue&type=script&lang=js"
export * from "./HeaderCenter.vue?vue&type=script&lang=js"
import style0 from "./HeaderCenter.vue?vue&type=style&index=0&id=7480e7a0&prod&lang=less&scoped=true"
import style1 from "./HeaderCenter.vue?vue&type=style&index=1&id=7480e7a0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7480e7a0",
  null
  
)

export default component.exports